"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FormListManager = void 0;
var form_list_manager_component_1 = require("./form-list-manager.component");
Object.defineProperty(exports, "FormListManager", { enumerable: true, get: function () { return form_list_manager_component_1.FormListManager; } });
